import React, { useState } from "react";
import { ChevronDown, ChevronUp, Brain } from "lucide-react";
import { MarkdownReact } from "@/components/MarkdownReact";
import { cn } from "@/lib/utils";

interface WorkflowRunViewReasoningProps {
  id: string;
  content: string;
  className?: string;
}

export const WorkflowRunViewReasoning: React.FC<
  WorkflowRunViewReasoningProps
> = ({ content, className }) => {
  const [isExpanded, setIsExpanded] = useState(false);

  return (
    <div className={cn("pl-11", className)}>
      <div className="border rounded-lg p-3 bg-muted">
        <button
          className="flex items-center gap-2 text-sm font-medium text-muted-foreground hover:text-foreground w-full"
          onClick={() => setIsExpanded(!isExpanded)}
        >
          <Brain className="h-4 w-4" />
          <span>Thinking</span>
          {isExpanded ? (
            <ChevronUp className="h-3 w-3 ml-auto" />
          ) : (
            <ChevronDown className="h-3 w-3 ml-auto" />
          )}
        </button>
        {isExpanded && (
          <div className="mt-2 text-xs text-muted-foreground prose-pre:whitespace-pre-wrap prose prose-sm prose-stone dark:prose-invert">
            <MarkdownReact>{content}</MarkdownReact>
          </div>
        )}
      </div>
    </div>
  );
};
